import { remindersGet } from "./remindersHttp";

/** Bell badge counts (admin feed unread + operation-request replies). */
export function fetchRemindersSummary() {
  return remindersGet("/summary");
}
